import MainBoard from './Main';

export default MainBoard
export { MainBoard as Base }
